import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  padding: 6px 8px;
  border-radius: 6px;
  border: 1px solid rgba(228, 215, 205, 1);
  background: rgba(249, 242, 236, 1);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
`

export const ChaptersEl = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  padding: 12px 18px;
  background: rgba(228, 215, 205, 1);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  color: rgba(89, 78, 71, 1);
`
